<template>
  <div id="app">
    <div id="nav"></div>
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>

export default {

}
</script>

<style>
html,
body {
  max-width: 100%;
  overflow-x: hidden;
}
</style>
